import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/_includes/braintree-note.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Docs mdxType="Docs" />
    <h1 {...{
      "id": "commerce-payment-provider-gateway"
    }}>{`Commerce payment provider gateway`}</h1>
    <h3 {...{
      "id": "what-is-adobe-commerce-payment-provider-gateway"
    }}>{`What is Adobe Commerce payment provider gateway`}</h3>
    <p>{`The Adobe Commerce payment provider gateway is a mechanism that allows you to integrate your stores with payment service providers. As a result, you can create and handle transactions based on order details.`}</p>
    <p>{`The following diagram shows a simplified interaction flow between Adobe Commerce sales management and external payment service provider using Commerce payment provider gateway:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "924px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/5530d/pg_interaction_flow.webp 320w", "/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/0c8fb/pg_interaction_flow.webp 640w", "/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/0ed23/pg_interaction_flow.webp 924w"],
            "sizes": "(max-width: 924px) 100vw, 924px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/dd4a7/pg_interaction_flow.png 320w", "/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/0f09e/pg_interaction_flow.png 640w", "/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/8643c/pg_interaction_flow.png 924w"],
            "sizes": "(max-width: 924px) 100vw, 924px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/commerce/php/static/fa85bcd3305842ce2d9bfa296b9eaa13/8643c/pg_interaction_flow.png",
            "alt": "Payment Gateway Interaction",
            "title": "Payment Gateway Interaction",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Commerce payment provider supports the following payment operations:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`authorize: process authorization transaction; funds are blocked on customer account, but not withdrawn`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`sale: process authorization transaction and capture automatically, funds are withdrawn`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`capture: withdraw previously authorized amount`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`refund: return previously withdrawn customer funds`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`void: cancel transfer of funds from customer account`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "whats-in-this-chapter"
    }}>{`What's in this chapter`}</h3>
    <p>{`The topics of this chapter are conceptual and describe the components of the Commerce payment provider gateway:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "payment-gateway-structure.md"
          }}>{`Payment provider gateway structure`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "gateway-command.md"
          }}>{`Gateway Command`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "command-pool.md"
          }}>{`Gateway Command Pool`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "request-builder.md"
          }}>{`Request Builder`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "gateway-client.md"
          }}>{`Gateway Client`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "response-validator.md"
          }}>{`Response Validator`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "response-handler.md"
          }}>{`Response Handler`}</a></p>
      </li>
    </ul>
    <h4 {...{
      "id": "terms-used"
    }}>{`Terms used`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Term`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Commerce sales management`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Commerce interfaces that provide the ability to create orders, invoices, and shipments.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Payment service provider, payment provider, payment processor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Online service for accepting electronic payments, like PayPal, Authorize.Net and so on.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data used for a transaction. Might include the following: `}<ul><li>{`Payment details`}</li><li>{`Order items`}</li><li>{`Shipping, billing addresses`}</li><li>{`Customer details`}</li><li>{`Taxes`}</li><li>{`Merchant's payment provider API credentials`}</li></ul></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      